module.exports = __webpack_public_path__ + "img/noapplet.d959817c.png";